import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    stepperDisplay: false,
    loading: false,
    navOrientation: '',
    allignmentPosition: '',
    formOccupancy: '40%',
    sections: {},
    banner: []
}

export const stepperReducer = createSlice({
    name: 'stepperReducer',
    initialState,
    reducers: {
        setStepperDisplay: (state, action) => {
            state.stepperDisplay = action.payload
        },
        setSections: (state, action) => {
            state.loading = true
            state.sections = action.payload
            state.loading = false
        },
        setBanner: (state, action) => {
            state.loading = true
            state.banner = action.payload
            state.loading = false
        },
        setNavOrientation: (state, action) => {
            state.navOrientation = action.payload
        },
        setCustomStyle : (state,action)=>{
            state.customStyle = action.payload
        },
        setAllignmentPosition: (state, action) => {
            state.allignmentPosition = action.payload
        },
        setFormOccupancy: (state, action) => {
            state.formOccupancy = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        }
    }
})

export const { setStepperDisplay, setSections, setBanner, setNavOrientation, setCustomStyle,setLoading, setFormOccupancy, setAllignmentPosition } = stepperReducer.actions

export default stepperReducer.reducer